__turbopack_context__.v({
  "icon": "DEeBhG_icon",
  "iconContainer": "DEeBhG_iconContainer",
});
